// Angular Imports
import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
// Shared Imports
import { isLoggedGuard } from '@shared/guards'

const routes: Routes = [
	{ path: '', redirectTo: 'form', pathMatch: 'full' },
	{
		path: '',
		loadChildren: () => import('./modules/auth/auth.module').then((m) => m.AuthModule),
	},
	{
		path: 'form',
		loadChildren: () => import('./modules/form/form.module').then((m) => m.FormModule),
		canActivate: [isLoggedGuard],
	},
	{ path: '**', redirectTo: 'form', pathMatch: 'full' },
]

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
})
export class AppRoutingModule {}
